import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';
import 'aos/dist/aos.css';
import AOS from 'aos';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FeedbackButton from '../components/FeedbackButton';
import routes from '../components/routes';
const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 600, // Faster animations
      once: true, // Prevent re-animations
      mirror: false, // Don’t animate on scroll up
    });
  }, []);

  // Small inner component so we can use useLocation (must be inside Router)
  const Main = () => {
    return (
      <>
        <Header />
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
        <Footer />
        <FeedbackButton />
      </>
    );
  };

  return (
    <Router>
      <Main />
    </Router>
  );
};

export default App;